import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchiproReceiptMark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 53,
	height: 40,
	viewBox: "0 0 53 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M52.7384 39.7262C50.3836 34.7729 48.0317 29.8211 45.6812 24.8736C45.6454 24.792 45.5852 24.6959 45.4863 24.64C45.3874 24.5841 45.2771 24.5698 45.1466 24.5698H36.9801C41.5378 20.3432 44.4458 14.3638 44.6321 7.70359C44.6421 7.32952 44.3383 7.02281 43.9628 7.02281H37.1865C37.1865 16.3932 29.5904 23.9908 20.2185 23.9908H18.0873C20.7245 18.4342 23.3573 12.8775 25.9873 7.31806C26.0231 7.23063 26.079 7.1389 26.1793 7.08444C26.2796 7.02998 26.3871 7.02424 26.5219 7.02424H37.2066L37.1965 6.99845L33.3612 0V0.00286645H19.2454C19.1493 0.00286645 19.0633 0.0100326 18.9874 0.0501629C18.9114 0.0917265 18.867 0.159088 18.8383 0.225017C14.8009 8.73838 10.7592 17.2632 6.71467 25.7995C4.51323 30.4403 2.31323 35.0825 0.111792 39.7262C0.0845604 39.7778 0.0644952 39.8322 0.0415636 39.891C0.0286645 39.9254 0.0143323 39.9612 0 39.9985H10.2361C10.3178 40.0057 10.4009 39.987 10.4683 39.9498C10.5356 39.9111 10.5829 39.8537 10.6001 39.7892C11.956 36.9185 13.3075 34.0606 14.6562 31.2142C14.692 31.1354 14.745 31.0537 14.8368 31.005C14.9285 30.9563 15.0088 30.9534 15.1478 30.9534H37.7096C37.8501 30.9534 37.9203 30.9591 38.0092 31.005C38.098 31.0523 38.1468 31.1254 38.1855 31.2042C39.537 34.0492 40.8842 36.8956 42.2257 39.7405C42.253 39.7964 42.3017 39.8824 42.3805 39.9268C42.4593 39.9713 42.5296 39.977 42.6528 39.9799H52.8502L52.7384 39.7233V39.7262Z",
		fill: "#222222"
	})]
});
const ForwardRef = forwardRef(SvgArchiproReceiptMark);
export { ForwardRef as ReactComponent };
